import React, { useState, useEffect } from 'react';
import Header from '../HeaderSection/Header';
import Footer from '../FooterSection/Footer';

const AccountDeletion = () => {
    const [currentStep, setCurrentStep] = useState(0);
    const [loading, setLoading] = useState(false);
    
    // Adım açıklamaları
    const steps = [
        {
            title: "Adım 1",
            description: "Profil sekmesine giriş yapılır",
            image: "/img/step-1.png" // Placeholder image, eklenecek
        },
        {
            title: "Adım 2",
            description: "Sağ üstte yer alan üç noktaya tıklanır",
            image: "/img/step-2.png" // Placeholder image, eklenecek
        },
        {
            title: "Adım 3",
            description: "Ayarlara tıklanır",
            image: "/img/step-3.png" // Placeholder image, eklenecek
        },
        {
            title: "Adım 4",
            description: "Hesap İşlemlerine girilir",
            image: "/img/step-1.png" // Placeholder image, eklenecek
        },
        {
            title: "Adım 5",
            description: "Hesabımı Sil butonuna tıklanır",
            image: "/img/step-1.png" // Placeholder image, eklenecek
        },
        {
            title: "Adım 6",
            description: "Çıkan pop-up'da \"Evet\" butonuna tıklanır",
            image: "/img/step-1.png" // Placeholder image, eklenecek
        }
    ];

    const nextStep = () => {
        if (currentStep < steps.length - 1) {
            setLoading(true);
            setCurrentStep(currentStep + 1);
            // Loader'ın kısa bir süre görünmesi için yapay gecikme
            setTimeout(() => {
                setLoading(false);
            }, 600);
        }
    };

    const prevStep = () => {
        if (currentStep > 0) {
            setLoading(true);
            setCurrentStep(currentStep - 1);
            // Loader'ın kısa bir süre görünmesi için yapay gecikme
            setTimeout(() => {
                setLoading(false);
            }, 600);
        }
    };

    const goToStep = (index) => {
        if (index >= 0 && index < steps.length) {
            setLoading(true);
            setCurrentStep(index);
            // Loader'ın kısa bir süre görünmesi için yapay gecikme
            setTimeout(() => {
                setLoading(false);
            }, 600);
        }
    };

    return (
        <div className="account-deletion-page">
            <div className="main">
                <Header imageData={"/img/logo-white.png"} />
                
                {/* Account Deletion Section */}
                <section 
                    className="section ptb_100" 
                    style={{ 
                        background: 'radial-gradient(circle, #2F2D51 0%, #1A1E28 100%)',
                        paddingTop: '150px'
                    }}
                >
                    <style>
                        {`
                        .lds-spinner {
                            color: official;
                            display: inline-block;
                            position: relative;
                            width: 80px;
                            height: 80px;
                        }
                        .lds-spinner div {
                            transform-origin: 40px 40px;
                            animation: lds-spinner 1.2s linear infinite;
                        }
                        .lds-spinner div:after {
                            content: " ";
                            display: block;
                            position: absolute;
                            top: 3px;
                            left: 37px;
                            width: 6px;
                            height: 18px;
                            border-radius: 20%;
                            background: #007bff;
                        }
                        .lds-spinner div:nth-child(1) {
                            transform: rotate(0deg);
                            animation-delay: -1.1s;
                        }
                        .lds-spinner div:nth-child(2) {
                            transform: rotate(30deg);
                            animation-delay: -1s;
                        }
                        .lds-spinner div:nth-child(3) {
                            transform: rotate(60deg);
                            animation-delay: -0.9s;
                        }
                        .lds-spinner div:nth-child(4) {
                            transform: rotate(90deg);
                            animation-delay: -0.8s;
                        }
                        .lds-spinner div:nth-child(5) {
                            transform: rotate(120deg);
                            animation-delay: -0.7s;
                        }
                        .lds-spinner div:nth-child(6) {
                            transform: rotate(150deg);
                            animation-delay: -0.6s;
                        }
                        .lds-spinner div:nth-child(7) {
                            transform: rotate(180deg);
                            animation-delay: -0.5s;
                        }
                        .lds-spinner div:nth-child(8) {
                            transform: rotate(210deg);
                            animation-delay: -0.4s;
                        }
                        .lds-spinner div:nth-child(9) {
                            transform: rotate(240deg);
                            animation-delay: -0.3s;
                        }
                        .lds-spinner div:nth-child(10) {
                            transform: rotate(270deg);
                            animation-delay: -0.2s;
                        }
                        .lds-spinner div:nth-child(11) {
                            transform: rotate(300deg);
                            animation-delay: -0.1s;
                        }
                        .lds-spinner div:nth-child(12) {
                            transform: rotate(330deg);
                            animation-delay: 0s;
                        }
                        @keyframes lds-spinner {
                            0% {
                                opacity: 1;
                            }
                            100% {
                                opacity: 0;
                            }
                        }
                        .loader-container {
                            display: flex;
                            flex-direction: column;
                            align-items: center;
                            justify-content: center;
                        }
                        `}
                    </style>
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-12 col-md-10 col-lg-8">
                                {/* Section Heading */}
                                <div className="section-heading text-center">
                                    <h2 className="text-white">Hesap Silme İşlemi</h2>
                                </div>
                            </div>
                        </div>
                        
                        <div className="row">
                            <div className="col-12">
                                <div className="account-deletion-content bg-white p-4 p-md-5 rounded shadow-lg" style={{ maxWidth: "900px", margin: "0 auto" }}>
                                    {/* Bilgilendirme Alanı */}
                                    <div className="mb-5">
                                        <h4 className="text-center mb-4">Önemli Bilgilendirme</h4>
                                        <div className="alert alert-warning">
                                            <p><strong>Hesabınızı silmeden önce aşağıdaki bilgileri dikkatlice okuyunuz:</strong></p>
                                            <ul className="mb-0 pl-3">
                                                <li className="mb-2">Hesap silme işlemi geri alınamaz. Hesabınızı sildikten sonra verilerinize erişim mümkün olmayacaktır.</li>
                                                <li className="mb-2">Hesabınızla ilişkili tüm veriler (profil bilgileri, etkinlik geçmişi, favori mekanlar ve takipler) kalıcı olarak silinecektir.</li>
                                                <li className="mb-2">Yaptığınız yorumlar ve değerlendirmeler anonim hale getirilecek, ancak sistemden tamamen kaldırılmayacaktır.</li>
                                                <li className="mb-2">Hesabınızı silmeden önce saklamak istediğiniz önemli bilgileri yedeklemenizi öneririz.</li>
                                                <li>Hesap silme işlemi 30 gün içinde tamamlanacaktır, bu süre zarfında uygulamaya tekrar giriş yaparsanız silme işlemi iptal edilecektir.</li>
                                            </ul>
                                        </div>
                                        <p className="mt-3 text-center">
                                            Eğer hesabınızı silme konusunda herhangi bir sorunuz varsa, lütfen <a href="mailto:destek@socia.co">destek@socia.co</a> adresine e-posta göndererek bizimle iletişime geçin.
                                        </p>
                                    </div>

                                    {/* Walkthrough Alanı */}
                                    <div>
                                        <h4 className="text-center mb-4">Hesap Silme Adımları</h4>
                                        
                                        {/* Step Gösterimi */}
                                        <div className="text-center mb-3">
                                            <span className="badge badge-primary py-2 px-3 font-weight-bold">
                                                {steps[currentStep].title}
                                            </span>
                                        </div>
                                        
                                        {/* Görsel Alanı */}
                                        <div className="walkthrough-image text-center mb-4" style={{ minHeight: "450px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                                            {loading ? (
                                                <div className="loader-container">
                                                    <div className="lds-spinner">
                                                        <div></div><div></div><div></div><div></div>
                                                        <div></div><div></div><div></div><div></div>
                                                        <div></div><div></div><div></div><div></div>
                                                    </div>
                                                    <p className="mt-3 text-primary font-weight-bold">Yükleniyor...</p>
                                                </div>
                                            ) : (
                                                <img 
                                                    src={steps[currentStep].image} 
                                                    alt={`Adım ${currentStep + 1}`}
                                                    className="img-fluid rounded shadow-sm"
                                                    style={{ 
                                                        maxHeight: "600px", 
                                                        width: "auto",
                                                        minWidth: "80%",
                                                        border: "1px solid #ddd",
                                                        objectFit: "contain"
                                                    }}
                                                    onLoad={() => setLoading(false)}
                                                />
                                            )}
                                        </div>
                                        
                                        {/* Açıklama */}
                                        <div className="walkthrough-description text-center mb-4">
                                            <h5 className="font-weight-normal">{steps[currentStep].description}</h5>
                                        </div>
                                        
                                        {/* Mobil uyumlu adım indikatörleri */}
                                        <div className="step-indicators text-center mb-4 d-none d-md-block">
                                            {steps.map((step, index) => (
                                                <button
                                                    key={index}
                                                    onClick={() => goToStep(index)}
                                                    className={`btn btn-sm mx-1 my-1 ${currentStep === index ? 'btn-primary' : 'btn-outline-primary'}`}
                                                    aria-label={`Adım ${index + 1}`}
                                                    disabled={loading}
                                                >
                                                    {index + 1}
                                                </button>
                                            ))}
                                        </div>
                                        
                                        {/* Küçük ekranlar için daha kompakt adım indikatörleri */}
                                        <div className="step-indicators-mobile text-center mb-4 d-md-none">
                                            <div className="btn-group" role="group" aria-label="Adım navigasyonu">
                                                {steps.map((step, index) => (
                                                    <button
                                                        key={index}
                                                        onClick={() => goToStep(index)}
                                                        className={`btn btn-sm ${currentStep === index ? 'btn-primary' : 'btn-outline-primary'}`}
                                                        aria-label={`Adım ${index + 1}`}
                                                        style={{
                                                            padding: '0.25rem 0.5rem',
                                                            fontSize: '0.75rem'
                                                        }}
                                                        disabled={loading}
                                                    >
                                                        {index + 1}
                                                    </button>
                                                ))}
                                            </div>
                                        </div>
                                        
                                        {/* İlerleme çubuğu */}
                                        <div className="progress mb-4" style={{ height: "8px" }}>
                                            <div 
                                                className="progress-bar bg-primary" 
                                                role="progressbar" 
                                                style={{ width: `${((currentStep + 1) / steps.length) * 100}%` }}
                                                aria-valuenow={((currentStep + 1) / steps.length) * 100}
                                                aria-valuemin="0" 
                                                aria-valuemax="100"
                                            ></div>
                                        </div>
                                        
                                        {/* Navigasyon Butonları - Mobil Uyumlu */}
                                        <div className="d-flex justify-content-between align-items-center">
                                            <button 
                                                className="btn btn-outline-primary btn-sm btn-md-regular" 
                                                onClick={prevStep} 
                                                disabled={currentStep === 0 || loading}
                                            >
                                                <i className="fas fa-arrow-left mr-1 mr-md-2"></i>
                                                <span className="d-none d-sm-inline">Önceki</span>
                                            </button>
                                            <div className="step-indicator">
                                                <span className="badge badge-light p-2">
                                                    {currentStep + 1} / {steps.length}
                                                </span>
                                            </div>
                                            <button 
                                                className="btn btn-primary btn-sm btn-md-regular" 
                                                onClick={nextStep} 
                                                disabled={currentStep === steps.length - 1 || loading}
                                            >
                                                <span className="d-none d-sm-inline">Sonraki</span>
                                                <i className="fas fa-arrow-right ml-1 ml-md-2"></i>
                                            </button>
                                        </div>
                                        
                                        <div className="text-center mt-5">
                                            <a href="/" className="btn btn-primary">Ana Sayfaya Dön</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                
                <Footer />
            </div>
        </div>
    );
};

export default AccountDeletion;